import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Button, Card, CardContent, Grid, IconButton, Pagination, Stack, TextField, Typography } from '@mui/material';
import config from 'src/config';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import showLoading from 'src/common/loading';
import { getContainers } from 'src/services/container.service';
import ContainerCardComponent from '../../components/containers/ContainerCard.component';
import { getProfile, updateProfile } from 'src/services/profile.service';

// ----------------------------------------------------------------------

const containerTypeMap = {
    'container': {
        name: 'Group',
        name_plural: 'Groups'
    },
    'department': {
        name: 'Department',
        name_plural: 'Departments'
    },
    'team': {
        name: 'Team',
        name_plural: 'Teams'
    },
    'project': {
        name: 'Project',
        name_plural: 'Projects'
    }
}


class BasicDetails extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            username: '',
            name: '',
            nick_name: '',

            containers: [],
            type: this.props?.payload?.type || 'container',
            search: '',
            limit: 12,
            skip: 0,
            total_containers: 0,
        }
    }

    getMapValue = (key) => {
        return containerTypeMap[this.state.type][key] || '';
    }

    // promised setState
    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve)
        });
    }

    async componentDidMount() {
        await this.fetchProfile();
    }

    fetchProfile = async(showLoader = true) => {
        try {

            if (showLoader)
                showLoading(true);


            const profile = await getProfile();
            if (profile.error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: profile.error,
                    confirmButtonText: 'Ok',
                    confirmButtonColor: config.primaryColor
                });
                return;
            }

            this.setState({
                name: profile?.name || '',
                nick_name: profile?.nick_name || '',
                username: profile?.username || '',
            });


            showLoading(false);
        } catch (error) {
            showLoading(false);
            console.error("Error fetching:", error.message)
        }
    }


    saveProfile = async() => {
        try {

            showLoading(true);

            const payload = {
                name: this.state.name,
                nick_name: this.state.nick_name,
            };

            const updatedProfile = await updateProfile(payload);
            if (updatedProfile.error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: updatedProfile.error,
                    confirmButtonText: 'Ok',
                    confirmButtonColor: config.primaryColor
                });
                return;
            }

            showLoading(false);

            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Profile updated successfully',
                confirmButtonText: 'Ok',
                confirmButtonColor: config.primaryColor
            });

        } catch (error) {
            showLoading(false);
            console.error("Error saving profile:", error.message)
        }
    }


    render() {
        return (
            <>
                <Helmet>
                    <title> {'Profile'} | {config.APP_NAME} </title>
                </Helmet>

                <Grid container justifyContent="center">
                    <Grid item xs={12} sm={12} md={8} lg={6}>
                        <Card>
                            <CardContent>
                                <Stack direction="column" spacing={1}>
                                    <TextField
                                        size='small'
                                        label={'Username'}
                                        disabled
                                        variant="outlined"
                                        fullWidth
                                        value={this.state.username}
                                    />
                                    <TextField
                                        size='small'
                                        label={'Name'}
                                        variant="outlined"
                                        fullWidth
                                        value={this.state.name}
                                        onChange={(e) => {
                                            this.setState({ name: e.target.value });
                                        }}
                                    />
                                    <TextField
                                        size='small'
                                        label={'Nick name'}
                                        variant="outlined"
                                        fullWidth
                                        value={this.state.nick_name}
                                        onChange={(e) => {
                                            this.setState({ nick_name: e.target.value });
                                        }}
                                    />
                                    {/* Update button */}
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.saveProfile}
                                    >
                                        Update Profile
                                    </Button>
                                </Stack>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </>
        );
    }
}

export default function (props) {
    const navigate = useNavigate();

    return <BasicDetails {...props} navigate={navigate} />;
}

const styles={
    fileNameStyles:{
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    }
}